/*
  Murray size chart — replaces the Kiwi Size Chart app.

  The link is rendered by snippets/murray-size-chart.liquid and then moved
  into the size row that Variant Image Swatch King builds. Swatch King
  renders asynchronously, so we watch the DOM for its size row and fall
  back to a spot above the add to cart button if it never appears.
*/
(function () {
  if (window.__murraySizeChartReady) return;
  window.__murraySizeChartReady = true;

  var holder = null;
  var modal = null;
  var link = null;
  var placed = false;
  var lastFocus = null;

  function sizeSlot() {
    // Swatch King's own slot for a size chart
    var slot = document.querySelector('.swatch-size-chart');
    if (slot) return slot;

    // Otherwise the label row of the option called Size
    var labels = document.querySelectorAll('.swatch-label-container .swatch-option-name');
    for (var i = 0; i < labels.length; i++) {
      if (/^size\b/i.test(labels[i].textContent.trim())) {
        return labels[i].closest('.swatch-label-container');
      }
    }
    return null;
  }

  function fallbackSpot() {
    return (
      document.querySelector('.product-single__meta .product-block--price') ||
      document.querySelector('.product-single__meta form [name="add"], .product-single__meta .add-to-cart')
    );
  }

  function place() {
    if (placed || !holder || !link) return;

    var slot = sizeSlot();
    if (slot) {
      slot.appendChild(link);
      holder.hidden = true;
      placed = true;
      return;
    }
    return false;
  }

  function placeFallback() {
    if (placed || !holder || !link) return;
    var spot = fallbackSpot();
    if (spot && spot.parentNode) {
      holder.classList.add('msc--standalone');
      holder.hidden = false;
      spot.parentNode.insertBefore(holder, spot);
      placed = true;
    }
  }

  function open() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('msc-lock');
    var panel = modal.querySelector('.msc-modal__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('msc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function init() {
    holder = document.getElementById('MurraySizeChart');
    modal = document.getElementById('MurraySizeChartModal');
    if (!holder || !modal) return;

    link = holder.querySelector('.msc__link');
    place();

    if (!placed) {
      var observer = new MutationObserver(function () {
        place();
        if (placed) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Swatch King never showed up: put the link above the buy button
      setTimeout(function () {
        observer.disconnect();
        placeFallback();
      }, 6000);
    }

    document.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-msc-open]')) {
        evt.preventDefault();
        open();
        return;
      }
      if (evt.target.closest('[data-msc-close]')) {
        evt.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.murraySizeChart = { open: open, close: close };
})();
